import React from "react";
import ContactUs from "./ContactUs/ContactUs";

const Contact = () => <ContactUs />;

export default Contact;
